import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appExternalLink]',
  standalone: true,
})
export class ExternalLinkDirective {
  @Input() appExternalLink!: string;

  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    const accepted = localStorage.getItem('predisclaimerAccepted');
    if (accepted === 'true') {
      window.open(this.appExternalLink, '_blank');
    } else {
      this.router.navigate(['/predisclaimer']);
    }
  }
}
